import { Component, OnInit, ViewChild, inject } from "@angular/core";
import { CerrixLoaderComponent } from "@app/shared/components/cerrix-loader/cerrix-loader.component";
import { MenuSystemDirective } from "@app/shared/directives/menu-system.directive";
import { FormOverviewComponent } from "./form-overview/form-overview.component";
import { UnreleasedFormOverviewComponent } from "./unreleased-form-overview/unreleased-form-overview.component";
import { FormsDataService } from "@app/forms/services/forms-data.service";
import { IdNameCombination } from "@models/generic/IdNameCombination";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { FormStatusComponent } from "./status-overview/form-status.component";
import { FormPermissionModel } from "@models/permissions/FormPermissionModel";
import { PermissionsService } from "@services/permissions/PermissionsService";
import { firstValueFrom } from "rxjs";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/forms/i18n/scope";

@Component({
    selector: "form-home",
    templateUrl: "./form-home.component.html",
    styleUrls: ["./form-home.component.scss"],
    imports: [
        CerrixLoaderComponent,
        MenuSystemDirective,
        FormOverviewComponent,
        FormStatusComponent,
        UnreleasedFormOverviewComponent,
        TranslatePipe,
    ],
    viewProviders: [provideTranslationScope(scope)],
})
export class FormHomeComponent implements OnInit {
    private _formDS = inject(FormsDataService);
    private permService = inject(PermissionsService);

    @ViewChild("status") status: FormStatusComponent;

    tab: TabModel;

    categories: IdNameCombination[];
    permissions = new FormPermissionModel();

    constructor() {
        this.permissions = this.permService.permissions.Forms;
    }

    async ngOnInit() {
        this.categories = await firstValueFrom(this._formDS.getOverviewCategories());
        this.tab.showLoader = false;
    }
}
